import { useEffect, useState } from "react";

export const useDataViewSelection = (records) => {
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const toggleRow = (recordId) => {
    setSelectedRowIds((currentSelectedRowIds) =>
      currentSelectedRowIds.includes(recordId)
        ? currentSelectedRowIds.filter(
            (currentRecordId) => currentRecordId !== recordId
          )
        : [...currentSelectedRowIds, recordId]
    );
  };

  const toggleAll = () => {
    const visibleRecordIds = records.map((record) => record._record_id).filter(Boolean);

    setSelectedRowIds((currentSelectedRowIds) => {
      const allVisibleRowsSelected =
        visibleRecordIds.length > 0 &&
        visibleRecordIds.every((recordId) =>
          currentSelectedRowIds.includes(recordId)
        );

      return allVisibleRowsSelected ? [] : visibleRecordIds;
    });
  };

  useEffect(() => {
    setSelectedRowIds((currentSelectedRowIds) =>
      currentSelectedRowIds.filter((recordId) =>
        records.some((record) => record._record_id === recordId)
      )
    );
  }, [records]);

  return {
    selectedRowIds,
    toggleRow,
    toggleAll,
    setSelectedRowIds,
  };
};
